import React from 'react';

import ShimmerComponent from '../../../shimmerComponent/shimmerComponent';

import './chatRoomTaskOwnerShimmerComponent.css';

const ChatRoomTaskOwnerShimmerComponent = () => {
  return (
    <div className="et-chat-room-task-owner-shimmer-container">
      <div className="et-crtoc-shimmer-mentor-photo">
        <ShimmerComponent />
      </div>
      <div className="et-crtoc-shimmer-mentor-name-info-wrap">
        <div className="et-crtoc-shimmer-mentor-name">
          <ShimmerComponent />
        </div>
        <div className="et-crtoc-shimmer-mentor-info-txt">
          <ShimmerComponent />
        </div>
        <div className="et-crtoc-shimmer-button">
          <ShimmerComponent />
        </div>
      </div>
    </div>
  );
};

export default ChatRoomTaskOwnerShimmerComponent;
